import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Modal from '../../shared/Modal'

import {connect} from '../../../state/hooks/tools'
import {deleteResource} from '../../../lib/asyncMethods'
import {SETTINGS} from '../../../state/actionTypes'

/**
 * The confirmation every settings row goes through before it is deleted, flag or not.
 *
 * A deleted row is gone rather than switched off: code that reads the name finds nothing, and a flag
 * that is not there reads as off. Making it again is a new row, so the dialog asks for the delete in
 * so many words instead of offering it from the card.
 */
const DeleteSetting = props => {
  const destroy = () => {
    props.deleteResource(`settings/${props.setting.id}`).then(response => {
      if (response.success)
        props.toggleModal()
    })
  }

  return (
    <Modal
      open={props.showModal}
      handleClose={props.toggleModal}
      disabled={props.loading}
      maxWidth='sm'
      buttonText='Cancel'
      title={`Delete ${props.setting.name}?`}>
        <Stack>
          <Typography gutterBottom>
            This removes the row for good. Anything still reading {props.setting.name} finds nothing
            there{props.setting.featureFlag && ', and treats the flag as off'}.
          </Typography>
          <Alert className='notice' severity='error'>
            It cannot be undone. Creating it again starts a new row with its own scope and value.
          </Alert>
          <Button disabled={props.loading} onClick={destroy} variant='contained' color='error'>
            Delete
          </Button>
        </Stack>
    </Modal>
  )
}

const mapStateToProps = ({metadata}) => ({loading: metadata.loading})

const actionCreators = ({metadata}) => ({deleteResource: deleteResource(metadata, SETTINGS)})

export default connect(mapStateToProps, actionCreators)(DeleteSetting)
